import styled from 'styled-components';

const LayoutContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding-top: 72px;
  background-color: ${({ theme }) => theme.Bg1};
  @media only screen and (max-width: 500px) {
    padding-top: 65px;
    margin-bottom: ${() =>
      location.pathname === '/'
        ? '120px'
        : location.pathname === '/following'
        ? '186px'
        : 'auto'};
  }
  .layout-wrapper {
    width: 1230px;
    margin: 0 8px;
    max-width: unset;
    margin-left: auto;
    margin-right: auto;
    .layout-sub-wrapper {
      display: grid;
      column-gap: 1rem;
      grid-template-rows: auto;
    }
    .sticky-sidebar {
      position: sticky;
      top: 100px;
    }
    .content {
      position: relative;
    }
    .aside-container {
      position: sticky;
      top: 72px;
    }
    .policy-container {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      font-size: 13px;
      color: #828282;
      margin-top: 4px;
      > div {
        margin-right: 8px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
  .no-page-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 0 80px 0;
    color: #c4c4c4;
    font-weight: 600;
    font-size: 22px;
    svg {
      width: 150px;
      height: 150px;
      margin-bottom: 10px;
    }
    button {
      margin-top: 20px;
    }
  }

  @media screen and (min-width: 1100px) {
    .layout-sub-wrapper {
      grid-template-columns: ${({ isshowaside }) =>
        isshowaside
          ? 'minmax(170px, 200px) minmax(650px, 650px) minmax(280px, 350px)'
          : 'minmax(170px, 200px) minmax(0, auto)'};
    }
  }

  @media screen and (min-width: 950px) and (max-width: 1099px) {
    .sidebar .menu-list {
      padding: 10px;
      > div {
        display: none;
      }
      svg {
        margin-right: 0;
      }
    }
    .layout-sub-wrapper {
      grid-template-columns: ${({ isshowaside }) =>
        isshowaside
          ? 'minmax(50px, 50px) minmax(650px, 650px) minmax(250px, 350px)'
          : 'minmax(50px, 50px) minmax(0, auto)'};
    }
  }

  @media screen and (min-width: 600px) and (max-width: 949px) {
    .sidebar .menu-list {
      padding: 10px;
      > div {
        display: none;
      }
      svg {
        margin-right: 0;
      }
    }
    aside {
      display: none;
    }
    .layout-sub-wrapper {
      grid-template-columns: ${({ isshowaside }) =>
        isshowaside
          ? 'minmax(50px, 50px) minmax(500px, 650px)'
          : 'minmax(50px, 50px) minmax(500px, 650px)'};
      justify-content: center;
    }
  }

  @media only screen and (max-width: 599px) {
    .sidebar,
    aside {
      display: none;
    }
    .layout-sub-wrapper {
      justify-content: normal !important;
    }
  }
`;

const FooterStyles = styled.div`
  .footer-default-height {
    height: 60px;
  }
  .footer-container {
    padding-bottom: env(safe-area-inset-bottom);
    height: 60px;
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${({ theme }) => theme.Bg1};
    z-index: 100;
    border-top: 1px solid ${({ theme }) => theme.lightGray};

    .icon-div {
      text-decoration: none;
      color: #333;
      text-align: center;
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      > div {
        margin-top: 8px;
        height: 18px;
        svg {
          width: 22px;
          height: 22px;
          fill: ${({ theme }) => theme.svg1};
        }
      }
      > label {
        margin-top: 4px;
        margin-bottom: 12px;
        font-size: 12px;
        // font-weight: 500;
        color: ${({ theme }) => theme.svg1};
      }
    }
    .active-fot {
      &.active-home {
        svg path {
          fill: #2d90ff;
        }
      }
      > label {
        color: #2d90ff;
      }
      > div {
        svg {
          fill: #2d90ff;
        }
      }
    }
  }
  .footer-align-evenly {
    justify-content: space-evenly;
  }
  .footer-default-height,
  .footer-container {
    @media screen and (max-width: 600px) {
      display: flex;
    }
    @media screen and (min-width: 600px) {
      display: none;
    }
  }
`;

const LandingContainer = styled.div`
  .landing-brand-container {
  }
  .landing-title-container {
    max-width: 1230px;
    margin: 0 auto;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .landing-title-bg {
    border-radius: 8px;
    margin: 12px 12px 0;
    padding: 20px;
  }
  .landing-brand {
    display: flex;
    align-items: center;
    z-index: 1;
    svg {
      width: 45px;
      height: 45px;
    }
    .landing-logo-title {
      color: #2b99f5;
      font-size: 28px;
      text-align: start;
      margin-left: 8px;
    }
  }
  .landing-nav {
    display: flex;
    align-items: center;
    > button {
      white-space: nowrap;
      margin-left: 8px;
      color: ${({ theme }) => theme.text1};
      font-weight: 600;
    }
  }
  .landing-auth-btn {
    display: flex;
    align-items: center;
    > button {
      width: 100px;
      white-space: nowrap;
      margin-left: 12px;
      border-radius: 8px !important;
    }
    .beforelogin-profile-container {
      height: 24px;
      margin-left: 8px;
      cursor: pointer;
      svg {
        fill: ${({ theme }) => theme.text1};
      }
    }
  }
  .landing-features-container {
    max-width: 1230px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .landing-features {
    padding: 12px 6px;
    h1 {
      margin: 0px;
      font-weight: 600;
      font-size: 50px;
      position: relative;
      display: inline-block;
      background: linear-gradient(
        -75deg,
        ${({ theme }) => theme.text1} 0%,
        ${({ theme }) => theme.text1} 40%,
        red 50%,
        ${({ theme }) => theme.text1} 60%,
        ${({ theme }) => theme.text1} 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 200% auto;
      animation: shine 5s linear infinite;
    }
    h2 {
      margin: 0px;
      margin-top: 10px;
      font-weight: 500;
      font-size: 30px;
      color: #828282;
    }
    @keyframes shine {
      0% {
        background-position: 200% center;
      }
      100% {
        background-position: 0% center;
      }
    }
  }
  .landing-lottie-network {
    svg {
      width: 600px !important;
      height: 550px !important;
    }
  }
  .landing-features-bg {
  }
  .landing-features-block {
    max-width: 1230px;
    margin: 0 auto;
  }
  .landing-features-title {
    text-align: center;
    font-size: 35px;
    font-weight: 500;
    margin: 50px 0 10px 0;
  }
  .landing-card-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2%;
    margin: 30px 20px 0;
  }
  @media screen and (max-width: 440px) {
    .landing-features-card .landing-card-image  > div {
      > svg {
        width: 100% !important;
      }
    }
  }
  .landing-features-card {
    border: 1px solid gray;
    padding: 10px 20px 10px;
    border-radius: 12px;
    width: 30%;
    font-size: 16px;
    li {
      margin-bottom: 12px;
    }
    .landing-card-title {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      margin-top: 30px;
    }
    .landing-card-image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .landing-card-job svg {
      width: 200px !important;
      height: 200px !important;
    }
    .landing-card-communication {
      height: 208px;
      svg {
        width: 300px !important;
        height: 225px !important;
      }
    }
    .landing-card-business {
      height: 208px;
      svg {
        width: 350px !important;
        height: 350px !important;
      }
    }
  }
  .landing-ai-bg {
    background: #210d25;
    border-radius: 8px;
    margin: 12px 12px 0;
    padding: 20px;
    margin-top: 50px;
  }
  .landing-ai-block {
    max-width: 1230px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .landing-ai-title {
    font-size: 22px;
    font-weight: 600;
    color: #fff;
  }
  .landing-ai-description {
    font-size: 14px;
    color: #bebebe;
  }
  .landing-ai-solution-card {
    border-radius: 8px;
    padding: 12px;
    margin-top: 20px;
    color: #333;
    > div {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 6px;
      text-align: center;
      background: #e0e0e0;
      border-radius: 8px;
      padding: 8px 0px;
    }
    li {
      font-size: 16px;
      margin-bottom: 6px;
    }
  }
  .landing-ai-solution-jobseeker {
    background-color: #fff;
  }
  .landing-ai-solution-employer {
    background-color: #fff;
  }
  .landing-ai-solution-left {
    width: 40%;
  }
  .landing-ai-solution-right {
    position: relative;
    video {
      height: 600px;
      border-radius: 12px;
    }
    .landing-ai-solution-helper {
      span {
        font-size: 35px;
      }
      font-size: 20px;
      font-weight: 600;
      color: #163e5f;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      bottom: -6px;
      text-align: center;
      width: 100%;
    }
    .landing-ai-solution-comingsoon {
      position: absolute;
      right: 0%;
      bottom: 0px;
      color: #fff;
    }
  }

  .landing-problem-bg {
  }
  .landing-problem-block {
    max-width: 1230px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2%;
    margin-top: 30px;
    img {
      width: 100%;
      max-height: 260px;
      object-fit: contain;
      border-radius: 12px;
      background: #e0e0e0;
    }
  }
  .landing-problem-card {
    min-height: 400px;
    box-shadow: ${({ theme }) => theme.boxShadow1};
    width: 40%;
    text-align: center;
    border-radius: 12px;
    padding: 8px;
  }
  .landing-problem-card-title {
    font-size: 20px;
    margin-bottom: 12px;
    text-align: center;
  }
  .landing-problem-title {
    width: fit-content;
    font-size: 16px;
    text-align: center;
    margin: 10px auto 20px;
    background: #f4f4f4;
    border-radius: 50px;
    padding: 6px 16px;
    color: #333;
  }
  .landing-problem-card-issues {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
    > div {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        display: inline-block;
        margin-right: 6px;
        font-size: 12px;
      }
    }
  }

  .landing-title-bg {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-size: 50px 50px;
      background-image: radial-gradient(circle, #7b7979ff 1px, transparent 1px);
      z-index: 0;
      height: 650px;
    }
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: 0;
    }
  }
  .landing-mobile-bg {
    border-radius: 8px;
    margin: 12px 12px 0;
    padding: 20px;
    margin-top: 50px;
    background: #210d25;
  }
  .landing-mobile-block {
    max-width: 1230px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .appstore-download-img {
    cursor: pointer;
    color: #000;
    margin-bottom: 30px;
    &:hover {
      color: #4c4c4c;
    }
  }
  .landing-mobile-download {
    width: 25%;
    text-align: center;
    > div {
      display: grid;
      justify-content: center;
    }
  }
  .landing-mobile-screen {
    width: 48%;
    text-align: center;
  }
  .landing-mobile-menu {
    width: 25%;
    display: grid;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    > div {
      margin-bottom: 20px;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    button {
      margin-top: 6px;
      border-radius: 8px !important;
      font-size: 15px !important;
      font-weight: 600;
    }
  }
  .fade-container {
    transition: opacity 0.4s ease-in-out;

    &.fade-out {
      opacity: 0.3;
    }

    &.fade-in {
      opacity: 1;
    }
  }
  .landing-mobile-download-description {
    font-size: 22px;
    color: #fff;
    margin-bottom: 30px;
  }
  .landing-footer-bg {
    border-radius: 8px;
    margin: 12px 12px 0;
    padding: 30px 20px 60px;
    margin-top: 20px;
    background: #e0e0e0;
  }
  .landing-footer-block {
    max-width: 1230px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .landing-logo-title {
      margin: 0px 0px 0px 8px;
    }
  }
  .landing-footer-card-container {
    color: #333;
    margin-right: 16px;
    .landing-footer-card-item {
      div {
        margin-bottom: 8px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }
  .landing-footer-title {
    font-size: 19px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .landing-footer-social-icon {
    margin-top: 20px;
    margin-left: 12px;
    svg {
      cursor: pointer;
      width: 26px;
      height: 26px;
      margin-right: 16px;
    }
  }
  @media screen and (max-width: 1000px) {
    .landing-lottie-network {
      display: none;
    }
    .landing-title-bg::before {
      height: 410px;
    }
  }
  @media screen and (max-width: 700px) {
    .landing-problem-card {
      width: 100%;
      margin: 10px;
    }
  }
  @media screen and (max-width: 1110px) {
    .landing-ai-solution-left {
      width: 100%;
    }
    .landing-ai-solution-right {
      display: none;
    }
  }
  @media screen and (max-width: 960px) {
    .landing-mobile-download {
      width: 100%;
    }
    .landing-ai-solution-left {
      width: 100%;
    }
    .landing-mobile-screen, .landing-mobile-menu {
      display: none;
    }
  }
  @media screen and (max-width: 1093px) {
    .landing-card-container {
      flex-wrap: wrap;
    }
    .landing-features-card {
      width: 100%;
      margin-top: 30px;
    }
  }
  @media screen and (max-width: 750px) {
    .landing-auth-btn {
      > button {
        display: none;
      }
    }
  }
  @media screen and (max-width: 500px) {
    .landing-logo-header-title {
      display: none;
    }
  }
  @media screen and (max-width: 610px) {
    .landing-features h1 {
      font-size: 40px;
    }
  }
  @media screen and (max-width: 430px) {
    .landing-title-bg {
      padding: 0px;
    }
    .landing-features h1 {
      font-size: 26px;
    }
    .landing-features h2 {
      font-size: 22px;
    }
  }
  @media screen and (max-width: 350px) {
    .landing-nav >button:nth-child(3) {
      display: none;
    }
  }
`;

export { LayoutContainer, FooterStyles, LandingContainer };
